import React, { useEffect, useState } from 'react'
import CMS from '../../../components/cms/CMS'
import CrudFormElements from './CrudFormElement'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { fetchFormGet } from '../../../redux/slices/formGetSlice'
import PageBanner from '../../../components/general/PageBanner'
import { fetchLanguageGetAll } from '../../../redux/slices/languageGetAllSlice'
import CMSTable from '../../../components/general/CMSTable'
import { fetchFormElementDelete } from '../../../redux/slices/formElementDeleteSlice'
import { columns } from '../../../utilities/columns/formElementsColumns'

const FormElementsPage = () => {
    const { t } = useTranslation()
    const { id } = useParams()
    const [modal, setModal] = useState(false)
    const [selectedItem, setSelectedItem] = useState(0)
    const [changed, setChanged] = useState(false)
    const lang = useSelector(state => state.lang.lang)
    const formElements = useSelector(state => state.formGet.data)
    const languages = useSelector(state => state.languageGetAll.data)
    const navigation = useNavigate()
    const dispatch = useDispatch()

    const getData = async () => {
        await dispatch(fetchLanguageGetAll())
        await dispatch(fetchFormGet({ id: id }))
        setChanged(false)
    }

    const deleteData = async (id) => {
        await dispatch(fetchFormElementDelete({ id: id }))
        getData()
    }

    useEffect(() => { getData() }, [dispatch, changed])

    return (
        <CMS>
            {formElements ? <>
                <PageBanner
                    title={`${formElements?.title[lang]}`}
                    description={t("form_management_description")}
                    modal={modal}
                    setModal={setModal}
                    buttonText={t("add_form_item")}
                />

                <CMSTable
                    columns={columns({
                        t: t,
                        modal: modal,
                        setModal: setModal,
                        lang: lang,
                        deleteData: deleteData,
                        navigation: navigation,
                        setSelectedItem: setSelectedItem
                    })}
                    data={formElements?.formElements}
                />

                <CrudFormElements
                    setChanged={setChanged}
                    showMenu={modal}
                    setShowMenu={setModal}
                    setSelectedItem={setSelectedItem}
                    selectedItem={selectedItem}
                    formGroupId={id}
                    languages={languages}
                    t={t}
                />
            </> : null}
        </CMS>
    )
}

export default FormElementsPage
